// Unpublished Work © 2022-2023 Deere & Company

import {useEffect} from 'react';
import {isFeatureToggled} from './feature-toggles';

export const useWalkmeScript = (url) => {
    useEffect(() => {
        if (isFeatureToggled('INSERT_WALKME_SCRIPT')) {
            const script = globalThis.document.createElement('script');

            script.type = 'text/javascript';

            script.src = url;
            script.async = true;

            const s = globalThis.document.getElementsByTagName('script')[0];

            s.parentNode.insertBefore(script, s);
            /* istanbul ignore next*/
            globalThis._walkmeConfig = {
                smartLoad: true
            };
        }
    }, [url]);
};
